<style scoped>
.google-map-pin {
  height: 40px;
  width: auto;
  position: absolute;
  z-index: 9;
  top: 43%;
  left: 44%;
}

.action-buttons {
  position: absolute;
  z-index: 9;
  bottom: 30px;
  width: 100%;
  padding: 15px;
}

.search-place {
  position: absolute;
  width: 100%;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>

<style>
#pac-input {
  position: absolute;
  top: 10px;
  border-radius: 0 !important;
  width: 100%;
}
</style>

<template>
  <div class="set-location-map-component">
    <div class="map-container">
      <img alt=" " src="@/assets/map-pin.png" class="google-map-pin" v-if="!readOnly"/>
      <div class="search-place">
        <Input placeholder="Search location" element-id="pac-input" style="width: 100%"></Input>
      </div>
      <div class="action-buttons">
        <Button type="primary" long v-on:click="onUpdate" :loading="locationLoader"
          v-if="!readOnly">{{submitLabel}}</Button>
        <Button type="primary" long v-on:click="hideMapMarker"
          v-if="readOnly">Update Location</Button>
      </div>
      <div id="map" style="height: 90vh;background: #f0f0f0;"></div>
    </div>
    <Spin fix style="z-index: 99" v-if="!pageLoader">
      <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
export default {
  name: "SetLocationMapComponent",
  props: {
    geoLocation: {
      type: Object,
      default: () => {
        return { lat: 0, long: 0 };
      }
    },
    type: {
      type: String,
      default: "work"
    },
    zoom: {
      type: Number,
      default: 4
    },
    mapStyle: {
      type: [Array, Object],
      default: function() {
        return [
          {
            featureType: "all",
            elementType: "geometry.fill",
            stylers: [
              {
                weight: "2.00"
              }
            ]
          },
          {
            featureType: "all",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#9c9c9c"
              }
            ]
          },
          {
            featureType: "all",
            elementType: "labels.text",
            stylers: [
              {
                visibility: "on"
              }
            ]
          },
          {
            featureType: "landscape",
            elementType: "all",
            stylers: [
              {
                color: "#f2f2f2"
              }
            ]
          },
          {
            featureType: "landscape",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#ffffff"
              }
            ]
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#ffffff"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "all",
            stylers: [
              {
                saturation: -100
              },
              {
                lightness: 45
              }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#eeeeee"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#7b7b7b"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#ffffff"
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "all",
            stylers: [
              {
                visibility: "simplified"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: [
              {
                color: "#46bcec"
              },
              {
                visibility: "on"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#c8d7d4"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#070707"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#ffffff"
              }
            ]
          }
        ];
      }
    },
    submitLabel: {
      type: String,
      default: "Save"
    },
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      geoLocationHolder: this.geoLocation,
      readOnlyHolder: this.readOnly,
      pageLoader: false,
      map: null,
      marker: null
    };
  },
  watch: {
    mapLoader: function(val) {
      if (val) {
        this.initializeGoogleMap();
      }
    },
    geoLocation: function(val) {
      if (val) {
        this.geoLocationHolder = val;
        if (this.mapLoader) {
          this.initializeGoogleMap();
        }
      }
    },
    readOnly: function(val) {
      if (val) {
        if (this.mapLoader) {
          this.showMapMarker();
        }
      }
    }
  },
  mounted() {
    if (this.mapLoader && this.geoLocation) {
      console.log("mounted");
      this.initializeGoogleMap();
    }
  },
  computed: {
    mapLoader: {
      get() {
        return this.$store.state.gmapLoaded;
      }
    },
    locationLoader: {
      get() {
        return this.$store.state.user.locationLoader;
      }
    }
  },
  methods: {
    initializeGoogleMap() {
      console.log("init");
      this.map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: this.geoLocation.lat, lng: this.geoLocation.long },
        zoom: this.zoom,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: this.mapStyle
      });

      if (this.readOnly) {
        this.showMapMarker();
      }

      this.map.addListener("dragend", () => {
        this.getLocation(this.map);
      });

      google.maps.event.addListenerOnce(this.map, "idle", () => {
        this.pageLoader = true;
      });

      let input = document.getElementById("pac-input");
      let searchBox = new google.maps.places.SearchBox(input);
      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

      this.map.addListener("bounds_changed", () => {
        searchBox.setBounds(this.map.getBounds());
      });

      var markers = [];

      searchBox.addListener("places_changed", () => {
        var places = searchBox.getPlaces();

        if (places.length == 0) {
          return;
        }

        // Clear out the old markers.
        markers.forEach(function(marker) {
          marker.setMap(null);
        });
        markers = [];

        // For each place, get the icon, name and location.
        var bounds = new google.maps.LatLngBounds();
        places.forEach(place => {
          if (!place.geometry) {
            console.log("Returned place contains no geometry");
            return;
          }
          var icon = {
            url: place.icon,
            size: new google.maps.Size(71, 71),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(17, 34),
            scaledSize: new google.maps.Size(25, 25)
          };

          // Create a marker for each place.
          markers.push(
            new google.maps.Marker({
              map: this.map,
              icon: icon,
              title: place.name,
              position: place.geometry.location
            })
          );

          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        this.map.fitBounds(bounds);
        this.getLocation(this.map);
      });
    },

    getLocation(map) {
      this.geoLocationHolder = {
        lat: map.getCenter().lat(),
        long: map.getCenter().lng()
      };
    },

    showMapMarker() {
      this.marker = new google.maps.Marker({
        position: { lat: this.geoLocation.lat, lng: this.geoLocation.long },
        map: this.map
      });
    },

    hideMapMarker() {
      this.marker.setMap(null);
      this.$emit("hideMarker", false);
    },

    onUpdate() {
      this.$emit("emitUpdate", {
        geoLocation: this.geoLocationHolder,
        type: this.type
      });
    }
  }
};
</script>
